import { ArrowLeftOutlined } from '@ant-design/icons';
import { type RichiestaModuloDTOStatoValidazione } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTOStatoValidazione.ts';
import { type SubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/SubmissionModuleState.ts';
import { type IBooleanCondition } from '@framework/engine/inputs/expressions-editor/conditions/IBooleanCondition.tsx';
import { t } from '@framework/i18n/intl/i18next.ts';
import { type BrandedPath } from '@framework/ui/core/router/TypedRoute.tsx';
import type React from 'react';

export enum SubmissionMenuItemType {
  Cover = 'cover',
  Guide = 'guide',
  Principal = 'principal',
  Module = 'module',
  Section = 'section',
  Attachments = 'attachments',
  Payment = 'payment',
  Send = 'send',
}

export interface ISubmissionMenuItem {
  key: string;
  index: string;
  name: string;
  type: SubmissionMenuItemType;
  children?: ISubmissionMenuItem[] | undefined;
  icon?: React.ReactNode;
  /** Conteggio mostrato come badge a fine riga (es. numero allegati). */
  count?: number;
  to?: BrandedPath;
  context?: {
    /** ID Richiesta modulo, utilizzato come nome per il formHandler del modulo, gestito dal formCoordinator */
    submissionModuleId?: string | null;
    /** ID sezione */
    sectionId?: string | null;
    validationState?: RichiestaModuloDTOStatoValidazione;
    state?: SubmissionModuleState;
  };
  visible?: IBooleanCondition;
  enabled?: IBooleanCondition;
}

/**
 * Primo elementi del menu della Domanda sempre presenti e non modificabili
 *
 * Sempre presente e non modificabile
 */
export const SubmissionBeforeMenuItem: ISubmissionMenuItem[] = [
  {
    key: 'cover',
    index: 'cover',
    name: t('submission-menu-item.scheda-domanda', 'Scheda Domanda'),
    type: SubmissionMenuItemType.Cover,
    icon: <ArrowLeftOutlined aria-hidden="true" />,
  },
];
